import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { setMissingDatesConfig } from '../../../../../redux/slices/oldBuilder';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';
import * as BuilderUI from '../../../../../components/Builder/BuilderUI';

interface IProps {
  includeMissingDates: boolean;
}

const MissingDateControl = ({ includeMissingDates }: IProps) => {
  const dispatch = useAppDispatch();
  const comparisonConfig = useAppSelector(
    ({ builder }) => builder.comparisonConfig,
  );
  const handleChange = (newValue: string) => {
    dispatch(
      setMissingDatesConfig({ includeMissingDates: newValue === 'true' }),
    );
  };

  const options = useMemo(() => {
    return [
      { name: 'Include', key: 'true' },
      {
        name: 'Exclude',
        key: 'false',
        disabled: !!comparisonConfig,
        tooltip: {
          content: 'Exclude will reset the comparison config',
        },
      },
    ];
  }, [comparisonConfig]);
  useEffect(() => {
    return () => {
      // fallback to default value if the component is unmounted
      if (!includeMissingDates) {
        dispatch(setMissingDatesConfig({ includeMissingDates: true }));
      }
    };
  }, [dispatch, includeMissingDates]);

  return (
    <>
      <BuilderEnumSelect
        label="date, with the option to"
        labelIsInSentence={true}
        enumOptions={options}
        selectedOption={includeMissingDates.toString()}
        onChange={handleChange}
      />
      <BuilderUI.InputLabel>missing dates.</BuilderUI.InputLabel>
    </>
  );
};

export default MissingDateControl;
